import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { getURLSegment, toggleDrawer, scrollToTop } from '../../helpers/helpers.js'

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';

const ExamStatus = observer(class ExamStatus extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.openEventsDrawer = this.openEventsDrawer.bind(this);
    this.renderProctorApprovals = this.renderProctorApprovals.bind(this);
    this.skipToFlags = this.skipToFlags.bind(this);
  }

  openEventsDrawer(e) {
    toggleDrawer(e, this.props.parent, 'IncidentReport');

    let { pathname } = this.props.routing.location;

    // Get the exam sid from the URL
    const examSid = getURLSegment(this, 2);
    pathname += `?eventsFor=${examSid}`;
    this.props.routing.push(pathname);
  }

  renderProctorApprovals() {
    const { translation } = this.props;

    return(
      <li className="card card--positive">
        <icons.iconUsers />
        <div className="card__content">
          <h3 className="card__heading">{this.props.pending} {translation.proctors_heading}</h3>
          <a className="card__btn" href="#ApproveProctor" onClick={(e) => {toggleDrawer(e, this.props.parent, 'ApproveProctor')}}>
            <icons.iconCheck />
            {translation.review_button}
          </a>
        </div>
      </li>
    );
  }

  skipToFlags(e) {
    e.preventDefault();
    
    const content = document.getElementById('automated-flags-report');

    if(content) {
      scrollToTop(e, content);
    }
  }

  render() {
    const { translation } = this.props;
    let { incidents, locked, pending, flags } = this.props;

    incidents = parseInt(incidents, 10);
    pending = parseInt(pending, 10);

    return(
      <ul className="card-list">
        {locked &&
          <li className="card">
            <icons.iconLock />
            <div className="card__content">
              <h3 className="card__heading">{translation.locked.heading}</h3>
              <p className="card__body">{translation.locked.body}</p>
            </div>
          </li>
        }
        {pending > 0 &&
          <FeatureFlag
            flagKey="instructor-proctor-approval"
            renderFeatureCallback={this.renderProctorApprovals}
          />
        }
        {incidents > 0 &&
          <li className="card card--warning">
            <icons.iconExclamation />
            <div className="card__content">
              <h3 className="card__heading">
                {this.props.incidents}

                {incidents > 1 &&
                  <span> {translation.incidents_heading}</span>
                }

                {incidents === 1 &&
                  <span> {translation.incidents_heading_singular}</span>
                }
              </h3>
              <button
                className="card__btn"
                onClick={(e) => {this.openEventsDrawer(e)}}
              >
                <icons.iconCheck />
                {translation.review_button}
              </button>
            </div>
          </li>
        }

        {flags > 0 &&
          <li className="card card--warning">
            <icons.iconExclamation />
            <div className="card__content">
              <h3 className="card__heading">
                {this.props.flags}

                {flags > 1 &&
                  <span> {translation.flags_heading}</span>
                }

                {flags === 1 &&
                  <span> {translation.flags_heading_singular}</span>
                }
              </h3>
              <a href="#" onClick={this.skipToFlags}>
                {translation.review_flags}
              </a>
            </div>
          </li>
        }
      </ul>
    )
  }
})

export default translate('ExamStatus')(ExamStatus);



// WEBPACK FOOTER //
// ./src/app/components/ExamDashboard/ExamStatus.js